import { useRef, useEffect } from 'react';

import { createAudio } from '../../../service/AudioService';
import type { PlayAudioCallbacks } from '../../../interface/PlayAudio';

export const useAudioPlayer = () => {
    const isPausedRef = useRef(false);
    const isPlayingRef = useRef(false);
    const audioRef = useRef<HTMLAudioElement>(createAudio());

    useEffect(() => {
        return () => {
            audioRef.current.pause();
            audioRef.current.src = '';
        };
    }, []);

    const playAudio = (url: string, callbacks: PlayAudioCallbacks) => {
        const { onPlay, onEnded, onError, force } = callbacks;

        if ((isPlayingRef.current || isPausedRef.current) && !force) return;

        const audio = audioRef.current;
        audio.src = url;
        isPlayingRef.current = true;

        audio.onplay = () => {
            onPlay?.();
        };
        
        audio.play().catch((error) => {
            console.error('Error playing audio URL:', error);
            onError?.(error);
        });

        audio.onended = () => {
            onEnded?.();
            isPlayingRef.current = false; // important this assignment happens after onEnd callback
        };
    };

    const pause = () => {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current.load();

        isPausedRef.current = true;
    };

    const resume = () => (isPausedRef.current = false);

    return { playAudio, isPlayingRef, audioRef, pause, resume };
};
